<template>
    <div class="social-combo">
        <div class="follow-us floating-box">
            <span>Follow Us</span>
            <div>
                <div class="fb-like" data-href="https://www.facebook.com/welcometopalestinecom/" data-layout="button_count" data-action="like" data-size="large" data-show-faces="true" data-share="false"></div>
                <a class="twitter-follow-button"
                   href="https://twitter.com/wtpalestine"
                   data-size="large">
                    Follow @wtpalestine</a>
            </div>
        </div>
        <social-sharing :url="url" inline-template>
            <div class="social-sharing floating-box">
                <span class="cta">Share this</span>
                <network network="facebook">
                    <i class="fa fa-fw fa-facebook" aria-hidden="true"></i> <span>Facebook</span>
                </network>
                <network network="twitter">
                    <i class="fa fa-fw fa-twitter" aria-hidden="true"></i> <span>Twitter</span>
                </network>
                <network network="reddit">
                    <i class="fa fa-fw fa-reddit" aria-hidden="true"></i> <span>Reddit</span>
                </network>
                <network network="whatsapp">
                    <i class="fa fa-fw fa-whatsapp" aria-hidden="true"></i> <span>Whatsapp</span>
                </network>
            </div>
        </social-sharing>
    </div>
</template>

<script>
	import SocialSharing from "vue-social-sharing";
	import Vue from "vue";
	Vue.use(SocialSharing);
	export default {
		computed: {
			url () {
				return window.location.href;
            }
        }
	}
</script>

<style lang="scss">
    @import "~foundation-sites/scss/foundation";


    .floating-box {
        width: 100%;
        padding: 1rem;
        background: white;
        box-shadow: 0 3px 10px 2px rgba(0,0,0,.1);
        border-radius: 5px;
        max-width: 100%;
        @include breakpoint(large) {
            max-width: calc(50% - .5rem);
        }
    }

    .follow-us {
        margin-bottom: 1rem;
        text-align: center;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        span {
            width: 100%;
            display: block;
            font-size: 1rem;
            font-weight: bold;
            margin-bottom: 1rem;
        }
        .fb-like,
        .twitter-follow-button {
            display: inline;
            line-height: 2.5rem;
        }
        @include breakpoint(large) {
            margin-bottom: 0;
        }
    }


    $base-color: #577f40;

    .social-combo {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        @include breakpoint(medium) {
            margin: 1rem auto;
            width: calc(100% - 4rem);
        }
        @include breakpoint (large) {
            justify-content: space-between;
        }
    }

    .social-sharing {
        @include breakpoint (large) {
            order: -1;
        }
        @include breakpoint(large) {
            margin-bottom: 0;
        }
        margin-bottom: 1rem;
        width: 100%;
        flex: 100% 0 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        span.cta {
            display: block;
            flex: 100% 0;
            margin-bottom: 1rem;
            font-weight: bold;
            font-size: 1rem;
            text-align: center;
        }
        span[data-link] {
            background: $base-color;
            color: white;
            padding: .75rem;
            border-radius: 5px;
            margin-right: .5rem;
            &:last-child {
                margin-right: 0;
                @include breakpoint(medium) {
                    margin-right: .5rem;
                }
            }
            &:nth-last-child(2) {
                @include breakpoint(medium) {
                    margin-right: 0;
                }
            }
            &[data-action="share/whatsapp/share"] {
                @include breakpoint(medium) {
                    display: none;
                }
            }
            transition: all 100ms;
            flex: auto;
            text-align: center;
            @include breakpoint(small only) {
                flex: 2 0;
                font-size: 1.35rem;
            }
            &:hover {
                cursor: pointer;
                background: lighten($base-color,10%);
            }
            span {
                @include breakpoint(small only) {
                    display: none;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// social.vue?4816c0e2